import Vue from 'vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

require('./bootstrap');

/**
 * Include the COTM admin theme
 */
require('babel-polyfill')

window.Vue = Vue;

Vue.use(VueLodash, { name: 'custom' , lodash: lodash })
Vue.use(BootstrapVue)


const axios = require('axios').default
axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
};

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

Vue.component('v-checkbox', require('./components/Fields/CheckboxField').default)
Vue.component('v-date-field', require('./components/Fields/DateField').default)
Vue.component('v-icon', require('./components/Icon').default)
Vue.component('v-input-field', require('./components/Fields/InputField').default)
Vue.component('v-multiselect', require('vue-multiselect').default)
Vue.component('v-image-file-field', require('./components/Fields/ImageField').default)
Vue.component('v-form', require('bootstrap-vue-laravel-form').default)
Vue.component('v-rich-text-field', require('./components/Fields/RichTextField').default)
Vue.component('v-file-field', require('./components/Fields/SelectOrUploadFileField').default)
Vue.component('v-form-group', require('./components/FormGroup').default)
Vue.component('v-select', require('./components/Fields/SelectField').default)
Vue.component('v-tags-field', require('./components/Fields/TagsField').default)
Vue.component('v-upload-file-field', require('./components/Fields/UploadFileField').default)
Vue.component('v-upload-field', require('./components/Fields/UploadField').default)
Vue.component('v-video-embed', require('./components/VideoEmbed').default)
Vue.component('v-video-field', require('./components/Fields/VideoField').default)
Vue.component('campus-listing', require('./components/Campuses/Listing').default)
Vue.component('campus-form', require('./components/Campuses/Form').default)
Vue.component('file-listing', require('./components/Files/Listing').default)
Vue.component('file-create', require('./components/Files/Create').default)
Vue.component('message-listing', require('./components/Messages/Listing').default)
Vue.component('message-campuses', require('./components/Messages/Campuses').default)
Vue.component('message-form', require('./components/Messages/Form').default)
Vue.component('campus-message-form', require('./components/Messages/CampusMessageForm').default)
Vue.component('series-form', require('./components/Series/Form').default)
Vue.component('series-listing', require('./components/Series/Listing').default)
Vue.component('speaker-listing', require('./components/Speakers/Listing').default)
Vue.component('speaker-form', require('./components/Speakers/Form').default)
Vue.component('user-form', require('./components/Users/Form').default)


const app = new Vue({
    el: '#wrapper'
});